export default class NullValidator {
  static get required() {
    return false;
  }

  static get pattern() {
    return '';
  }

  static get maxLength() {
    return null;
  }

  static get minLength() {
    return null;
  }

  static get customErrorMessage() {
    return '';
  }
}
